import { render, staticRenderFns } from "./SidebarsLayout.vue?vue&type=template&id=1f831f11&scoped=true&"
import script from "./SidebarsLayout.vue?vue&type=script&lang=js&"
export * from "./SidebarsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SidebarsLayout.vue?vue&type=style&index=0&id=1f831f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f831f11",
  null
  
)

export default component.exports